module.exports = __webpack_public_path__ + "static/media/pull-cart.75d6e5ab.svg";